import React from 'react'
import PropTypes from 'prop-types'

import { CURRENT_FILTER, TLM_FILTER } from '../../../constants/commons'
import * as f from '../../../classes/Filters'
import { DefaultFilters } from '../../../reducers/topics_reducer'
import * as TLM from '../../../constants/tlm'
class MediaTypeFilterComponent extends React.Component {
  static propTypes = {
    setFilters: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    module: PropTypes.string.isRequired
  }

  render () {
    return (
      <ul className="checkList">
        <li><h4>Media Type Filters (OR)</h4></li>
        {this.li(TLM.BRAND, TLM.BRAND)}
        {this.li(TLM.CHANNEL, TLM.CHANNEL)}
        {this.li(TLM.GAMING, TLM.GAMING)}
        {this.li(TLM.LIFESTYLE, TLM.LIFESTYLE)}
        {this.li(TLM.MOVIE, TLM.MOVIE)}
        {this.li(TLM.MUSIC, TLM.MUSIC)}
        {this.li(TLM.PEOPLE, TLM.PEOPLE)}
        {this.li(TLM.SHOW, TLM.SHOW)}
      </ul>
    )
  }

  li = (filter, text) => {
    // let currentValue = this.props.filters && !this.props.filters.equals(DefaultFilters) && this.props.filters.filters.find(f => f.topic_sub_type === filter)
    let currentValue = this.props.filters && this.props.filters.filters.find(f => f.topic_sub_type === filter)
    const value = currentValue ? true : false
    return (
      <li>
        <input
          type="checkbox" id={`${text}`}
          checked={value}
          onChange={this.filterByTopicSubtype.bind(this, filter)} />
        <span></span>
        <label htmlFor={`${text}`}>{text}</label>
      </li>
    )
  }

  filterByTopicSubtype = (type) => {
    let filters = this.props.filters

    if (this.props.filters.equals(DefaultFilters)) {
      filters = new f.Filters([])
    }
    const filter = new f.Filter({ topic_sub_type: type })
    filters = this.props.filters.consolidateToTopicSubTypes()
    filters = filters.toggle(filter)

    //TLM and Mediatype should be displayed in the plan DWA-1720
    if (type === TLM.SHOW || type === TLM.MOVIE) {
      const keys = Object.keys(this.props.selectedPlanFilters)
      if (keys.indexOf(TLM_FILTER) > -1 && this.props.selectedPlanFilters[TLM_FILTER].length > 0) {
        let filter = this.props.selectedPlanFilters[TLM_FILTER]
        filter.forEach(f => {
          f.subType = f.subType && f.subType.indexOf(type) > -1 ? f.subType.filter(s => s !== type)
            //: f.subType && f.subType.indexOf(type) < 0 ? f.subType.push(type)
            : undefined
        })
        this.props.setFilters(filter, TLM_FILTER, this.props.module)
      } else {
        this.props.setFilters(filters, CURRENT_FILTER, this.props.module)
      }
    } else {
      this.props.setFilters(filters, CURRENT_FILTER, this.props.module)
    }
  }
}

export default MediaTypeFilterComponent